"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var react_1 = tslib_1.__importDefault(require("react"));
var mobx_react_1 = require("mobx-react");
var TilesList = /** @class */ (function (_super) {
    tslib_1.__extends(TilesList, _super);
    function TilesList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TilesList.prototype.render = function () {
        var children = this.props.children;
        return react_1.default.createElement("div", { className: "tiles-list" }, children);
    };
    TilesList = tslib_1.__decorate([
        mobx_react_1.inject('store'),
        mobx_react_1.observer
    ], TilesList);
    return TilesList;
}(react_1.default.Component));
exports.TilesList = TilesList;
exports.TileItem = function (_a) {
    var href = _a.href, image = _a.image, title = _a.title, subtitle = _a.subtitle, openInNewTab = _a.openInNewTab, _b = _a.size, size = _b === void 0 ? 'default' : _b;
    return (react_1.default.createElement("a", { href: href, target: openInNewTab ? '_blank' : undefined, className: "tile-item tile-item_" + size },
        react_1.default.createElement("span", { className: "tile-item__image", style: {
                backgroundImage: "url(\"" + image + "\")",
            } }),
        react_1.default.createElement("span", { className: "tile-item__footer" },
            react_1.default.createElement("span", { className: "tile-item__title", title: title }, title),
            subtitle && (react_1.default.createElement("span", { className: "tile-item__subtitle", title: subtitle }, subtitle)))));
};
